export default "__VITE_ASSET__D7Kp8aYV__"